module.exports = __webpack_public_path__ + "static/img/4062_phase_function_Paper_Points.cd18702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4062_phase_function_Paper_Points.png
// module id = itbR
// module chunks = 0